import type { InvariantRoute } from '@atlassian/react-resource-router/src/common/types';

export const rapidboardUserBacklogRoute: InvariantRoute = {
	name: 'rapidboard-user-backlog',
	path: '/jira/people/:accountId/boards/:boardId/backlog',
};
